import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import "./PopUpStyless.css"

const country = process.env.REACT_APP_COUNTRY;

const PopUp = ({ show, handleClose, title }) => {
    const formUrl = country === "UY"
        ? "https://forms.office.com/pages/responsepage.aspx?id=2qwNnw-plE6AL1RPBaVfBkVyRCGup4NEvO14EDVK50BUMTA4OFdYUEhKWTJJOFBCNjZGOVJDTjY5TS4u&origin=lprLink&route=shorturl"
        : country === "ARG" ? "https://www.solutionbox.com.ar/marcas/LEC"
        :"";

    const imageUrl = country === "UY"
        ? `${process.env.PUBLIC_URL}/imagenes/Popups/PopUpUY.png`
        : country === "ARG"
        ? `${process.env.PUBLIC_URL}/imagenes/Popups/PopUpARG.jpg`
        : "";

    const handleImageClick = () => {
        window.open(formUrl, '_blank');
    };

    const handleVisitClick = () => {
        handleClose();
        handleImageClick();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            dialogClassName="custom-modal"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header closeButton className="custom-modal-header">
                <Modal.Title className="custom-modal-title">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 custom-modal-body">
                <img
                    src={imageUrl}
                    alt="Banner"
                    className="img-fluid w-100"
                    style={{ cursor: 'pointer', display: 'block' }}
                    onClick={handleImageClick}
                />
            </Modal.Body>
            <Modal.Footer className="custom-modal-footer">
                <Button
                    variant="danger"
                    onClick={handleVisitClick}
                    className="custom-modal-button"
                >
                    Ver
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PopUp;